<div class="search-bar-child-ages-container">
  <div class="child-ages-grid">
    <ng-container *ngFor="let item of [].constructor(childrenQuantity); let i = index; trackBy: trackById">
      <div class="child-age" [class.active]="isActive(i)" [class.isActive]="toggleIsShow">
        <app-dropdown-select
          #dropdown
          [id]="'age-dropdown-selector-' | uniqueId :i :idSelector"
          [selectOptions]="ages"
          [fullWidth]="true"
          [inChildrenAges]="true"
          [defaultOption]="defaultAgeValue(i)"
          [title]="'SEARCH_MODULE.CHILDREN.SELECT_AGE' | transloco"
          [inputLabel]="'SEARCH_MODULE.CHILDREN.CHILD' | transloco: { item: (i + 1) }"
          [inputIsFilled]="true"
          [defaultSelection]="'SEARCH_MODULE.CHILDREN.SELECT_AGE' | transloco"
          (selected)="ageSelection($event, i)"
          [isMobile]="isMobile"
          (showOptionsEmitter)="toggleShow($event)">
        </app-dropdown-select>
      </div>
    </ng-container>
  </div>
</div>
